(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    // Stale Ships: fix-up. The drawer already PRINTS the live date (see the
  // liquid above); this rewrites the stored line property to match, so the
  // checkout and the confirmation email — which print the stored value —
  // agree with what the drawer showed. Runs once per line key per page, on
  // load and after every cart update; a line whose stored value already
  // matches carries no data-wallie-ships-live and is never touched. Uses the
  // line KEY, not its index: a change can merge two lines of one variant
  // and shift every index below it. change.js REPLACES properties, so the
  // whole set is sent back with only Ships changed.
  (function () {
    var done = {};
    function fix() {
      var els = document.querySelectorAll('.cart-items__property[data-wallie-ships-live]');
      if (!els.length) return;
      var todo = [];
      els.forEach(function (el) {
        var row = el.closest('[data-key]');
        var key = row && row.getAttribute('data-key');
        if (!key || done[key]) return;
        done[key] = true;
        todo.push({ key: key, live: el.getAttribute('data-wallie-ships-live') });
      });
      if (!todo.length) return;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          return todo.reduce(function (chain, job) {
            return chain.then(function () {
              var item = null;
              items.forEach(function (it) { if (it.key === job.key) item = it; });
              if (!item || !item.properties || item.properties.Ships === job.live) return;
              var props = {};
              Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
              props.Ships = job.live;
              return fetch('/cart/change.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: job.key, quantity: item.quantity, properties: props })
              }).then(function () {}, function () {});
            });
          }, Promise.resolve());
        })
        .catch(function () {});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
    else fix();
    document.addEventListener('cart:update', function () { setTimeout(fix, 0); });
  })();
  } catch(e) { console.error(e); }
})();

})();
